<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch"
                    :colSpan="4" />
                </Col>
            </Row>
        </transition>

        <Card :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">漏补退定金</span>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>

        <DepositOrderDetail ref="depositOrderDetailModal" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import DepositOrderDetail from '@/view/preSale-management/preSale-order/deposit-order-detail';
import { getUnPaidBackOrderList, remarkOrderdeposite, paybackOrderdeposite, exportPreSaleOrderList, withdrawPreSaleOrder } from '@/api/modules/preSale-management/preSale-order';
import {
    getOrderDeliveryStatusOptions,
    getOrderPaidStatusOptions
} from '@/view/preSale-management/preSale-order/PreSaleOrderStatus';
import { numberToFixed } from '@/components/number-input/display-format';

const getYesOrNoOptions = () => {
    const status = [
        {
            label:'是',
            val:1
        }, {
            label:'否',
            val:0
        }];

    return status.map(s => {
        return { key: s.label, value: s.val };
    });
};


export default {
    name: 'OrderPaybackList',
    components: {
        StandPaginationTable,
        SearchCard,
        DepositOrderDetail
    },
    data() {
        return {
            btnLoading: false,
            mainTable: {
                tableColumns: [
                    { title: '定单编号', key: 'depositBillRecordCode', width: 140, align: 'center' },
                    { title: '会员名称', key: 'userPersonName', width: 100, align: 'center' },
                    { title: '会员账号', key: 'userName', width: 80, align: 'center' },
                    { title: '定单合计', key: 'totalMoney', width: 80, align: 'center' },
                    { title: '已付定金', key: 'depositBillRecordDepositPaymentSum', width: 80, align: 'center' },
                    { title: '支付状态', key: 'depositBillRecordPaidStatus', width: 80, align: 'center' },
                    { title: '苗场状态', key: 'depositBillRecordshipStatus', width: 80, align: 'center' },
                    { title: '发货时间', key: 'depositBillRecordSendProductDate', width: 120, align: 'center', render: (h, params) => dateTimeRender(h, params.row.depositBillRecordSendProductDate) },
                    { title: '下单时间', key: 'depositBillRecordCreateAt', width: 130, align: 'center', render: (h, params) => dateTimeRender(h, params.row.depositBillRecordCreateAt) },
                    {
                        title: '定金已退', key: 'depositBillRecordIsDepositPayBack', align: 'center',
                        width: 80,
                        render: (h, params) => {
                            let text = params.row.depositBillRecordIsDepositPayBack === 1 ? '是' : '否';
                            if (params.row.action === -1) {
                                return "";
                            }
                            else {
                                return h('div', [
                                    h('span', {}, text)
                                ]);
                            }
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 100,
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return "";
                            }
                            else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        on: {
                                            click: () => {
                                                this.$refs.depositOrderDetailModal.showModal(params.row.depositBillRecordUuid);
                                            }
                                        }
                                    }, '查看'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {
                                            visibility: params.row.depositBillRecordIsDepositPayBack === 0 ? 'visible' : 'hidden'
                                        },
                                        on: {
                                            click: () => {
                                                this.pabBackDeposite(params.row);
                                            }
                                        }
                                    }, '补退')
                                ]);
                            }
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '定单编号', type: 'Input', value: '', name: 'depositBillRecordCode', sql: 'like' },
                    { label: '会员', type: 'Input', value: '', name: 'concat(userPersonName,userName)', sql: 'like' },
                    { label: '会员手机', type: 'Input', value: '', name: 'userPhone', sql: 'like' },
                    { label: '下单时间', type: 'Daterange', value: '', name: 'depositBillRecordCreateAt', sql: 'dateBetween' },
                    { label: '发货时间', type: 'Daterange', value: '', name: 'depositBillRecordSendProductDate', sql: 'dateBetween' },
                    {
                        label: '定金已退',
                        type: 'Select',
                        value: [],
                        name: 'depositBillRecordIsDepositPayBack',
                        sql: 'in',
                        options: getYesOrNoOptions()
                    }
                ]
            }
        };
    },
    props: {
        userType: { type: String, default: '' }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getMainTableRecords();
        },
        pabBackDeposite(row) {
            this.$Modal.confirm({
                title: '确认补退该定单定金: ￥' + row.depositBillRecordDepositPaymentSum,
                onOk: () => {
                    paybackOrderdeposite({ preSaleOrderRecordUuid: row.depositBillRecordUuid }).then(res => {
                        if (res.code === 0) {
                            this.init();
                            this.$Message.success('补退成功');
                        }
                    });
                }
            });
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "userType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'userType',
                    type: 'eq',
                    value: this.userType
                });
            }
            getUnPaidBackOrderList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
